var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mobileView == true)?_c('top-bar',{attrs:{"ul":this.ul}}):_c('topbar-mobile',{attrs:{"ul":this.ul}}),_c('router-view',{attrs:{"ul":this.ul}}),_c('footer-area',{attrs:{"ul":this.ul}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }